export default __webpack_public_path__ + "static/media/modalImg2.6d217b44.svg";